export function getValidUrlForLink(link: string) {
  if (link.startsWith('http')) return link;
  return `https://${link.slice()}`;
}
